// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProgressBar_wrapper","progress":"ProgressBar_progress"};